import React, { createContext, useContext, useState } from "react";
import { RoomChatMessagesDisplayState } from "./RoomChatTypes";

export type ChatMessagesContextType = {
    latestMessages: RoomChatMessagesDisplayState;
    setLatestMessages: (messages: RoomChatMessagesDisplayState) => void;
};

export const ChatMessagesContext: React.Context<ChatMessagesContextType | undefined> = createContext<
    ChatMessagesContextType | undefined
>(undefined);

interface ChatMessagesContextProviderProps {
    children?: React.ReactNode;
}

export const ChatMessagesContextProvider = ({ children }: ChatMessagesContextProviderProps) => {
    const [latestMessages, setLatestMessages] = useState<RoomChatMessagesDisplayState>({});

    return (
        <ChatMessagesContext.Provider value={{ latestMessages, setLatestMessages }}>
            {children}
        </ChatMessagesContext.Provider>
    );
};

export const useChatMessagesContext = () => {
    const context = useContext(ChatMessagesContext);
    if (context == null) {
        throw new Error("Missing ChatMessageContext");
    }
    return context;
};
